import { Controller } from "@hotwired/stimulus"

// Auto-dismisses notices; alerts persist until the user dismisses them (an
// error should not disappear before it's read — see data-flash-auto-dismiss
// in shared/_flash). Clears its timers on disconnect so a Turbo visit can't
// fire a callback against a detached element.
export default class extends Controller {
  static targets = ["message"]
  static values = { delay: { type: Number, default: 6000 }, exitDuration: { type: Number, default: 200 } }

  connect() {
    this.timers = []
    this.messageTargets.forEach((message) => {
      if (message.classList.contains("hidden")) return
      if (message.dataset.flashAutoDismiss !== "true") return
      // clearTimeout on disconnect — the existing timer controllers in this repo
      // leak theirs; don't copy that part.
      this.timers.push(setTimeout(() => this.#hide(message), this.delayValue))
    })
  }

  disconnect() {
    this.timers?.forEach(clearTimeout)
    this.timers = []
  }

  dismiss(event) {
    this.#hide(event.currentTarget.closest("[data-flash-target='message']"))
  }

  #hide(message) {
    if (!message || message.classList.contains("hidden")) return
    // Fade out first, then swap flex->hidden — matches the transition set on
    // the element in shared/_flash; snapping straight to display:none reads
    // as a glitch.
    message.classList.add("opacity-0", "-translate-y-1")
    this.timers.push(setTimeout(() => {
      message.classList.remove("flex", "opacity-0", "-translate-y-1")
      message.classList.add("hidden")
    }, this.exitDurationValue))
  }
}
